// extracted by mini-css-extract-plugin
export default {"wrapper":"Ys9463BX66F1JJoLf07w","loadingIcon":"T3vqTw1Dguc8zAM49Za4","emptyState":"KWQS07rJcyFKeGK1XuXN","widgets":"zmVogaIbVAkjWAhmUsuj","widget":"pLAkSBVhtfUnUe8DhuWN"};